import { isDefined } from "@clipboard-health/util-ts";

import { formatArrivalTime } from "./formatArrivalTime";

export function getUrgentArrivalPillLabel(
  targetArrivalTime: Date | undefined,
  timezone: string
): string | undefined {
  if (!isDefined(targetArrivalTime)) {
    return undefined;
  }

  return `Please arrive by ${formatArrivalTime(targetArrivalTime, timezone)}`;
}
